import { defineComponent as _defineComponent } from 'vue'
import { PropType } from 'vue'
import { IWaiter } from '@entities/order/model/types'
import { AppButton } from '@shared/ui'


export default /*#__PURE__*/_defineComponent({
  __name: 'ReviewReturn',
  props: {
  tipsType: {
    type: String as PropType<string>,
    required: true,
    default: 'TAPPER'
  },
  waiter: {
    type: Object as PropType<IWaiter | null>,
    required: true
  },
  rating: {
    type: Number as PropType<number>,
    required: true,
    default: 0
  }
},
  emits: ['sendReview'],
  setup(__props, { emit }) {

const props = __props





return { __sfc: true,emit, props, AppButton }
}

})